import React, { Component } from 'react';
import './pay.css';
import {API_URL} from "../../ajax/config";
import CheckboxIcoNot from "../../style/image/CheckboxIcoNot.png";
import CheckboxIcoHave from "../../style/image/CheckboxIcoHave.png";
import {get, post,} from "../../ajax/tools";
import PopUp from "../round/PopUp";



class PayWeChat extends Component {

    constructor(props){
        super(props);
        this.state = {
            orderId:'',//二维码的orderId
            InvoiceToggleOn: true,//全选框
            InvoiceBgImg:'url('+CheckboxIcoNot+')',//全选框的背景图
            InvoiceTitToggleOn: '',
            InvoiceTitle: '',
            InvoiceNumber: '',
            InvoiceSave: false,

            OrderIdInfo:{},
            OrderInfo:{realpay:0,},
        };
    }
    UNSAFE_componentWillReceiveProps= (nextProps) => {
        const history = nextProps;
        this.setState({
            OrderIdInfo:history.OrderIdInfo,
        });
    };
    componentDidMount=function() {
        const history = this.props;
        this.setState({
            OrderIdInfo:history.OrderIdInfo,
        });
        get({url:"payment/order_fee/"+history.OrderIdInfo.OrderID}).then(res => {
            if (res.errno === '200') {
                this.setState({
                    OrderInfo:res.data[0],
                });
                if(res.data[0].is_invoice === 1){
                    this.setState({
                        InvoiceSave: true,
                    });
                }
            }else {
                this.setState({
                    PopUp:'提示弹窗',
                    MessageTip:res.errmsg+'！',
                });
            }
        });
        this.PayWeChat= setInterval(() => {
            get({url:"payment/order_fee/"+history.OrderIdInfo.OrderID}).then(res => {
                if (res.errno === '200') {
                    if(res.data[0].status === 1){
                        clearInterval(this.PayWeChat);
                        this.props.PayPageSuccess('Success');
                        if(res.data[0].is_invoice === 1){
                            this.setState({
                                InvoiceSave: true,
                            });
                        }
                        this.setState({
                            OrderInfo:res.data[0],
                        });
                    }
                }
            });
        }, 2000);
    };

    componentWillUnmount = () => {
        this.setState = ()=>{
        };
    };

    PayTypeBackBtn(){
        clearInterval(this.PayWeChat);
        this.props.PayPageSuccess('PayTypeBack');
    };


    InvoiceCheckbox=()=>{
        this.setState(prevState => ({
            InvoiceToggleOn: !prevState.InvoiceToggleOn,
            InvoiceBgImg:prevState.InvoiceToggleOn ? 'url('+CheckboxIcoHave+')' : 'url('+CheckboxIcoNot+')',
        }));
    };

    InvoiceTitPe(){
        this.setState({
            InvoiceTitToggleOn: '个人',
        });
    };

    InvoiceTitGr(){
        this.setState({
            InvoiceTitToggleOn: '公司',
        });
    };

    InvoiceTitle(event){
        //event.target.value = event.target.value.replace(/[^\d]/g, '').replace(/^0/g,'');
        this.setState({
            InvoiceTitle: event.target.value,
        });
    };
    InvoiceNumber(event){
        //event.target.value = event.target.value.replace(/[^\d]/g, '').replace(/^0/g,'');
        this.setState({
            InvoiceNumber: event.target.value,
        });
    };


    InvoiceSaveBtn(){
        let InvoiceTitToggleOn = this.state.InvoiceTitToggleOn;
        let InvoiceTitle = this.state.InvoiceTitle;
        let InvoiceNumber = this.state.InvoiceNumber;
        let OrderID = this.state.OrderIdInfo.OrderID;
        if(InvoiceTitToggleOn !==''&& InvoiceTitle !==''&& InvoiceNumber!==''){
            post({
                url:'exam/add_invoice',
                data:{
                    order_id:OrderID,
                    invoice_type:InvoiceTitToggleOn === '个人' ? '0' : (InvoiceTitToggleOn === '公司' ? '1' : ''),
                    invoice_top:InvoiceTitle,
                    invoice_code:InvoiceNumber,
                },
            }).then((res) => {
                if(res.errno === '200'){
                    get({url:"payment/order_fee/"+OrderID}).then(res => {
                        if (res.errno === '200') {
                            this.setState({
                                OrderInfo:res.data[0],
                            });
                            if(res.data[0].is_invoice === 1){
                                this.setState({
                                    InvoiceSave: true,
                                });
                            }
                        }else {
                            this.setState({
                                PopUp:'提示弹窗',
                                MessageTip:res.errmsg+'！',
                            });
                        }
                    });
                }else {
                    this.setState({
                        PopUp:'提示弹窗',
                        MessageTip:res.errmsg+'！',
                    });
                }
            });
        }else {
            this.setState({
                PopUp:'提示弹窗',
                MessageTip:'您还有必要信息未填写！',
            });
        }
    };




    //提示弹窗
    ChildBackTip=(event)=>{
        if(event === 'CrossOut'){
            this.setState({
                PopUp:'',
            });
        }else if(event === 'Confirm'){
            this.setState({
                PopUp:'',
            });
        }
    };

    render() {
        return (
            <div className={'PayBoxes scrollBar'} style={{height:window.innerHeight-310,}}>
                {/*<div className={'PayTypeBackBtn'} onClick={this.PayTypeBackBtn.bind(this)}> </div>*/}
                <div className={'PayTitleBox clearfix'}>
                    <div className={'PayCodeBox'} style={{borderColor:'#77CD38',}}>
                        <img
                            className={'PayCodePhoto'}
                            alt={''}
                            src={API_URL+"/payment/WXpay_exam_order/"+this.state.OrderIdInfo.OrderID}
                        />
                    </div>
                    <div className={'PayCodeTipsWord'}>请使用手机微信扫一扫</div>
                    <div className={'PayMoneyWord'} style={{marginRight:56,}}>元</div>
                    <div className={'PayMoney￥Word'}>￥{this.state.OrderInfo.realpay}</div>
                    <div className={'PayMoneyWord'}>支付</div>
                </div>
                <div className={'PayInfoTitBox'}>
                    <div className={'PayInfoTit'}>产品信息</div>
                </div>
                <div className={'PayInfoBox'} style={{marginBottom:20,}}>
                    <div className={'PayInfoHeaderBox'}>
                        <div className={'PayInfoHeaderList'} style={{width:320,borderRight:'2px solid #DCDCDC',}}>收款方</div>
                        <div className={'PayInfoHeaderList'} style={{width:320,borderRight:'2px solid #DCDCDC',}}>产品</div>
                        <div className={'PayInfoHeaderList'} style={{width:320,}}>合计</div>
                    </div>
                    <div className={'PayInfoMainBox'}>
                        <div className={'PayInfoMainList'} style={{width:320,borderRight:'2px solid #DCDCDC',}}>中国航协模拟飞行服务平台</div>
                        <div className={'PayInfoMainList'} style={{width:320,borderRight:'2px solid #DCDCDC',}}>测试项目费用</div>
                        <div className={'PayInfoMainList'} style={{width:320,}}>￥{this.state.OrderInfo.realpay}</div>
                    </div>
                </div>
                <div className={'PayInfoTitBox'} style={{marginBottom:20,}}>
                    <div className={'InvoiceInfoCheckbox'}
                         style={{backgroundImage:this.state.InvoiceBgImg}}
                         onClick={this.InvoiceCheckbox.bind(this)}
                    > </div>
                    <div className={'InvoiceInfoTit'}>发票<span style={{color:'#7B7B7B',}}>(勾选是否需要发票)</span></div>
                </div>
                {
                    this.state.InvoiceToggleOn === false && this.state.InvoiceSave === false &&
                    <div>
                        <div className={'PayInfoTitBox'} style={{marginBottom:20,}}>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:98,}}>*抬头类型</div>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:24,}} onClick={this.InvoiceTitPe.bind(this)}>
                                <div className={'InvoiceInfoListIco'} style={{backgroundColor:this.state.InvoiceTitToggleOn === '个人' ? '#00B7EF' : ''}}> </div>
                                <span style={{cursor:'pointer',}}>个人</span>
                            </div>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:24,}} onClick={this.InvoiceTitGr.bind(this)}>
                                <div className={'InvoiceInfoListIco'} style={{backgroundColor:this.state.InvoiceTitToggleOn === '公司' ? '#00B7EF' : ''}}> </div>
                                <span style={{cursor:'pointer',}}>公司</span>
                            </div>
                        </div>
                        <div className={'PayInfoTitBox'} style={{marginBottom:20,}}>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:98,}}>*发票抬头</div>
                            <input className={'InvoiceInput'}
                                   type={'text'}
                                   name={'InvoiceTitle'}
                                   value={this.state.InvoiceTitle}
                                   onChange={this.InvoiceTitle.bind(this)}
                                   placeholder={''}
                                   autoComplete={'off'}
                            />
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:54,}}>*纳税人识别号</div>
                            <input className={'InvoiceInput'}
                                   type={'text'}
                                   name={'InvoiceNumber'}
                                   value={this.state.InvoiceNumber}
                                   onChange={this.InvoiceNumber.bind(this)}
                                   placeholder={''}
                                   autoComplete={'off'}
                            />
                        </div>
                        <button className={'InvoiceSaveBtn'} onClick={this.InvoiceSaveBtn.bind(this)}>保存</button>
                    </div>
                }
                {
                    this.state.InvoiceToggleOn === false && this.state.InvoiceSave === true &&
                    <div>
                        <div className={'PayInfoTitBox'} style={{marginBottom:20,}}>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:98,}}>*抬头类型</div>
                            {
                                this.state.OrderInfo.invoice_type === 0&&
                                <div className={'InvoiceInfoListTit'} style={{marginLeft:24,}}>
                                    <span style={{cursor:'pointer',}}>个人</span>
                                </div>
                            }
                            {
                                this.state.OrderInfo.invoice_type === 1&&
                                <div className={'InvoiceInfoListTit'} style={{marginLeft:24,}} onClick={this.InvoiceTitGr.bind(this)}>
                                    <span style={{cursor:'pointer',}}>公司</span>
                                </div>
                            }
                        </div>
                        <div className={'PayInfoTitBox'} style={{marginBottom:20,}}>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:98,}}>*发票抬头</div>
                            <div className={'InvoiceInputYes'}>{this.state.OrderInfo.invoice_top}</div>
                            <div className={'InvoiceInfoListTit'} style={{marginLeft:54,}}>*纳税人识别号</div>
                            <div className={'InvoiceInputYes'}>{this.state.OrderInfo.invoice_code}</div>
                        </div>
                    </div>
                }
                {
                    this.state.PopUp === '提示弹窗' &&
                    <PopUp
                        ChildBackClick={this.ChildBackTip.bind(this)}
                        type={'提示'}
                        message={this.state.MessageTip}
                        OutButton={'Yes'}
                    />
                }
            </div>
        );
    }
}


export default PayWeChat;
